const { wlGlobalConfig, wlApiConfig, wlAlgolia } = window;

export const ENV = wlGlobalConfig.__environment;
export const SITE_URL = wlGlobalConfig.__site_url;

export const GOOGLE_MAPS_API_KEY = wlGlobalConfig.__google_maps_api_key;

export const MAPBOX_API_KEY = wlGlobalConfig.__mapbox_api_key;

export const OKTA_BASE_URL = wlGlobalConfig.__okta_base_url;
export const OKTA_CLIENT_ID = wlGlobalConfig.__okta_client_id;

export const API_URL = wlApiConfig.url;
export const API_WP_REST_NONCE = wlApiConfig.wp_rest_nonce;
export const API_WL_API_NONCE = wlApiConfig.wl_api_nonce;

export const ALGOLIA_APP_ID = wlAlgolia ? wlAlgolia.application_id : '';
export const ALGOLIA_SEARCH_API_KEY = wlAlgolia ? wlAlgolia.search_api_key : '';
